module.exports = __webpack_public_path__ + "static/media/phone.c1f9edbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/contacts/phone.svg
// module id = 363
// module chunks = 0